import React, { useState, useEffect } from "react";
import { Button, Modal, Row } from "react-materialize";
import $ from "jquery";
import config from "config";
import Html from "utils/Html";
import BtnSubmitAddByEmail from "components/notify/features/table/btn.submit.add.email";
import { useNotify } from "context/NotifyContext";
import FormFunc from "utils/FormFunc";
import Func from "utils/Func";
import API from "hooks/useNotify";

const Feature = {};
Feature.Content = function ({ filterData, addData, handleEvents }) {
  let content = [];
  const boxName = "content-addnew";
  const selectOptions = {
    "select-senttype": handleEvents.GetSelectOptions(
      "select-senttype",
      addData
    ),
    "select-countries": handleEvents.GetSelectOptions(
      "select-countries",
      addData
    ),
    "select-agent_code": handleEvents.GetSelectOptions(
      "select-agent_code",
      addData
    ),
    "select-salesoffice": handleEvents.GetSelectOptions(
      "select-salesoffice",
      addData
    ),
    "select-department": handleEvents.GetSelectOptions(
      "select-department",
      addData
    ),
  };
  content.push(
    <div
      key="conten-add-new-box"
      className="row"
      style={{ padding: "0 10px", paddingTop: "0px" }}
    >
      <Row className={boxName} style={{ marginBottom: "5px" }}>
        <FormFunc.InputText
          data={{
            name: "email",
            label: "Email",
            addClass: "col s12",
            defaultValue: addData.staffEmail,
            disabled: false,
          }}
          events={handleEvents}
        />
      </Row>
      <Row className={boxName} style={{ marginBottom: "5px" }}>
        <FormFunc.SingleSelect
          data={{
            id: "",
            name: "select-type",
            label: "Notification type*",
            options: filterData.data.email_recips,
            addClass: "col s10",
            optionName: "name",
            optionValue: "value",
            //optionTitle: "---",
            defaultValue: addData["select-type"],
          }}
          events={handleEvents}
        />
        <FormFunc.SingleSelect
          data={{
            id: "",
            name: "select-senttype",
            label: "TO/CC/BCC*",
            options: selectOptions["select-senttype"],
            addClass: "col s2",
            optionName: "name",
            optionValue: "value",
            optionTitle: "---",
            disabled:
              selectOptions["select-senttype"].length === 0 ? true : false,
            defaultValue: addData["select-senttype"],
          }}
          events={handleEvents}
        />
      </Row>
      <Row className={boxName} style={{ marginBottom: "5px" }}>
        <FormFunc.SingleSelect
          data={{
            id: "",
            name: "select-countries",
            label: "Country*",
            options: selectOptions["select-countries"],
            addClass: "col s6",
            optionName: "name",
            optionValue: "name",
            optionTitle: "---",
            disabled:
              selectOptions["select-countries"].length === 0 ? true : false,
            defaultValue: addData["select-countries"],
          }}
          events={handleEvents}
        />
        <FormFunc.SingleSelect
          data={{
            id: "",
            name: "select-salesoffice",
            label: "Sales Office",
            options: selectOptions["select-salesoffice"],
            addClass: "col s6",
            optionName: "name",
            optionValue: "name",
            optionTitle: "---",
            disabled:
              selectOptions["select-salesoffice"].length === 0 ? true : false,
            defaultValue: addData["select-salesoffice"],
          }}
          events={handleEvents}
        />
      </Row>
      <Row className={boxName} style={{ marginBottom: "10px" }}>
        <FormFunc.SingleSelect
          data={{
            id: "",
            name: "select-agent_code",
            label: "Agent Code",
            options: selectOptions["select-agent_code"],
            addClass: "col s6",
            optionName: "name",
            optionValue: "value",
            optionTitle: "---",
            disabled:
              selectOptions["select-agent_code"].length === 0 ? true : false,
            defaultValue: addData["select-agent_code"],
          }}
          events={handleEvents}
        />
        <FormFunc.SingleSelect
          data={{
            id: "",
            name: "select-department",
            label: "Department",
            options: selectOptions["select-department"],
            addClass: "col s6",
            optionName: "name",
            optionValue: "name",
            optionTitle: "---",
            disabled:
              selectOptions["select-department"].length === 0 ? true : false,
            defaultValue: addData["select-department"],
          }}
          events={handleEvents}
        />
      </Row>
    </div>
  );

  return content;
};

export default function ModalAddNewByEmail({ userData }) {
  const { filters, filterData, dispatch } = useNotify();
  const defaultAddData = {
    key_form: 0,
    index: -1,
    "staffEmail": "",
    "select-type": 0,
    "select-senttype": "",
    "select-countries": "None",
    "select-salesoffice": "",
    "select-agent_code": "",
    "select-department": "",
    status: "",
    err: 0,
    err_msg: "",
  };
  const [addData, setAddData] = useState({ ...defaultAddData });
  let header = "Add New Email Recipient By Email";
  let content = "";
  let footer = "";
  let btns = [<div className="header">{header}</div>];
  let modalCSS = {};
  modalCSS.maxWidth = "700px";
  modalCSS.height = "70%";
  modalCSS.maxHeight = "470px";
  const handleEvents = {};
  handleEvents.SubmitForm = {
    OnSubmit: async function (evt) {
      // console.log("addData=>", addData);
      if (addData?.email === "" || addData?.["select-type"] === 0) {
        return "";
      }
      setAddData({ status: "inprocess" });
      try {
        const response = await API.addNewByEmail({
          addData: addData,
          userID: window.$user_profile.idu,
          staffEmail: addData.staffEmail,
        });
        // console.log(response);
        if (response?.err === 1) {
          setAddData({ err: 1, err_msg: response.err_msg });
        } else {
          setAddData(response);
          dispatch({
            type: "STORE_FILTERS",
            payload: {
              ...filters,
              isOpenModalAddNewByEmail: false,
              keyChange: Func.GetKeyRandom(),
            },
          });
        }
      } catch (error) {
        console.error("Error while calling API:", error);
        setAddData({ err: 1, err_msg: "Error while calling API" });
      }
    },
    OnChange: function (evt) {
      setAddData({
        ...addData,
        staffEmail: evt.target.value,
      });
    },
    OnSelectChange: function (evt, { id, name, value }) {
      if (name === "select-type") {
        const recipData = filterData.data.email_recips.find(
          (item) => item.value === parseInt(value)
        );
        const index = recipData?.index ?? -1;
        setAddData({
          ...defaultAddData,
          index: index,
          staffEmail: addData?.staffEmail ?? "",
          "select-type": parseInt(value),
          key_form: Func.GetKeyRandom(),
        });
      } else {
        setAddData({
          ...addData,
          [name]: value,
          key_form: Func.GetKeyRandom(),
        });
      }
    },
    OnClose: function () {
      $("body").css({ overflow: "auto" });
      setAddData({ ...defaultAddData });
      dispatch({
        type: "STORE_FILTERS",
        payload: {
          ...filters,
          isOpenModalAddNewByEmail: false,
        },
      });
    },
    GetSelectOptions: function (name, data) {
      if (data.index === -1) {
        return [];
      }
      const recipData = filterData.data.email_recips[data.index];
      const relate_field = recipData?.relate_field ?? [];
      if (name === "select-senttype" && relate_field.indexOf(name) >= 0) {
        return filterData.data.senttypes;
      } else if (
        name === "select-countries" &&
        relate_field.indexOf(name) >= 0
      ) {
        const countries = [...filterData.data.countries];
        const searchData = Func.SearchObject(
          countries,
          "EXOGROUP",
          "country_code"
        );
        if (Object.keys(searchData).length > 0) {
          const index = Object.keys(searchData)[0];
          countries.splice(index, 1);
        }
        return countries;
      } else if (
        name === "select-salesoffice" &&
        relate_field.indexOf(name) >= 0
      ) {
        return filterData.data.salesoffice;
      } else if (
        name === "select-agent_code" &&
        relate_field.indexOf(name) >= 0
      ) {
        const type = data["select-type"];
        const countries = data["select-countries"];
        if (
          (type === 5 || type === 9) &&
          filterData.data.agents["xml"]?.[countries]
        ) {
          return filterData.data.agents["xml"][countries];
        } else if (filterData.data.agents["booking"]?.[countries]) {
          return filterData.data.agents["booking"][countries];
        }
      } else if (
        name === "select-department" &&
        relate_field.indexOf(name) >= 0
      ) {
        const countries = data["select-countries"];
        if (filterData.data.departments?.[countries]) {
          return filterData.data.departments[countries];
        }
      }
      return [];
    },
  };

  if (addData?.err === 1) {
    modalCSS.height = "200px";
    btns.push(
      <Button
        flat
        modal="close"
        node="button"
        waves="red"
        className="modal-close"
      >
        <i className="material-icons">close</i>
      </Button>
    );
    content = (
      <div className="text-error">Fetch request error: {addData.err_msg}</div>
    );
  } else if (addData?.status === "inprocess") {
    content = (
      <div>
        <Html.Preloading
          addon={{
            css: {
              position: "absolute",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              margin: "auto",
            },
          }}
        />
      </div>
    );
  } else {
    //console.log("View", itemData);
    btns.push(
      <Button
        flat
        modal="close"
        node="button"
        waves="red"
        className="modal-close"
      >
        <i className="material-icons">close</i>
      </Button>
    );

    content = (
      <div
        className="modal-content-outer"
        style={{
          bottom: "auto",
        }}
      >
        <div key="modal-content-inner" className="modal-content-inner">
          <Feature.Content
            filterData={filterData}
            addData={addData}
            handleEvents={handleEvents.SubmitForm}
          />
        </div>
        <div key="modal-loading" className="modal-loading hide">
          <Html.Preloading
            addon={{
              css: {
                position: "absolute",
                top: "0",
                left: "0",
                right: "0",
                bottom: "0",
                margin: "auto",
              },
            }}
          />
        </div>
      </div>
    );

    footer = (
      <div className="modal-footer-bottom">
        <span className="modal-error-text hide"></span>
        <BtnSubmitAddByEmail handleEvents={handleEvents.SubmitForm} />
      </div>
    );
  }

  return (
    <Modal
      actions={btns}
      bottomSheet={false}
      fixedFooter={false}
      className="modal-user modal-user-footer"
      id="modal-user-view"
      open={filters.isOpenModalAddNewByEmail}
      options={{
        dismissible: true,
        endingTop: "10%",
        inDuration: 250,
        onCloseEnd: null,
        onCloseStart: () => handleEvents.SubmitForm.OnClose,
        onOpenEnd: null,
        onOpenStart: null,
        opacity: 0.5,
        outDuration: 250,
        preventScrolling: true,
        startingTop: "5%",
      }}
      root={document.getElementById("root")}
      style={modalCSS}
    >
      {content}
      {footer}
    </Modal>
  );
}
